import React, { useEffect, useState } from 'react';
import { faAngleLeft, faEdit, faFileAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Col, Row } from 'reactstrap';

//Components
import MainCard from '../../../../components/MainCard';
import ModalCustomized from '../../../../components/Modal/Modal';
import TabelaListagemFichas from '../../../../components/TabelaListagemFichas/TabelaListagemFichas';
import TextField from '../../../../components/TextField';

//API
import variaveisSistema_api from '../../../../api/variaveisSistema_api';
import layoutDiarioOficial_api from '../../../../api/layoutDiarioOficial_api';

//Context
import { useAuth } from '../../../../context/auth';

//Helpers
import { showMessage } from '../../../../helpers/message';
import { objCampo, validarCampos } from '../../../../helpers/ValidadorDeCampos';
import { getSessionCookie } from '../../../../helpers/cookies';


function initialStateLayoutDiarioOficial(secretaria_Id) {
    return {
        identificacao: "",
        cabecalho: "",
        item: "",
        secretaria_Id: secretaria_Id
    }
}

function CadastroLayoutDiarioOficial({ id, handleVoltar }) {
    //Objeto do token
    const session = getSessionCookie();

    //State para criar / editar 
    const [layoutDiarioOficial, setLayoutDiarioOficial] = useState(initialStateLayoutDiarioOficial(session.secretaria_Id));

    //Estado de controle dos campos de erro
    const [errors, setErrors] = useState({});

    //State de lista de Variaveis do sistema
    const [listaVariaveisSistema, setListaVariaveisSistema] = useState([]);

    //State para visibilidade do modal
    const [isModalListaVariaveis, setIsModalListaVariaveis] = useState(false);

    //State para alterar o state do modal
    const toggleModalListaVariaveis = () => setIsModalListaVariaveis(!isModalListaVariaveis);

    const { setLoading } = useAuth();

    //Cabeçalhos que a tabela terá
    const headersListaDeVariaveis = [
        { value: "Código", objectValue: "codigo", align: "left" },
        { value: "Descrição", objectValue: "descricao", align: "left" }
    ];

    //Estado de controle dos campos obrigatorios 
    const [campos, setCampos] = useState([
        objCampo({ name: "identificacao", required: true }),
        objCampo({ name: "item", required: true }),
    ]);

    const loadListaVariaveisSistema = () => {
        setLoading(true);
        variaveisSistema_api.getList()
            .then(response => {
                setListaVariaveisSistema(response.data);
            })
            .catch(err => showMessage("Error", err?.message ?? "Error na operação.", "error", null))
            .finally(() => setLoading(false));
    }


    //Função de load do documento para atualização
    const loadDiarioOficial = (id = null) => {
        if (id != null || layoutDiarioOficial?.id != null) {
            setLoading(true);
            layoutDiarioOficial_api.getItem(layoutDiarioOficial?.id ?? id)
                .then(response => {
                    setLayoutDiarioOficial(response.data);
                })
                .catch(err => showMessage("Error", err?.message ?? "Error na operação.", "error", null))
                .finally(f => setLoading(false));
        }
    }

    useEffect(() => {
        loadDiarioOficial(id);
        loadListaVariaveisSistema();
    }, []);

    const onChange = (e) => {
        const { name, value } = e.target;
        const _layoutDiarioOficial = {
            ...layoutDiarioOficial,
            [name]: value
        };

        //Validando erros no campo especifico para checar em tempo de digitação se ele possui algum erro
        const _campos = campos.filter(campo => campo.name === name);
        const fieldError = validarCampos(_layoutDiarioOficial, _campos);

        const _errors = { ...errors };
        delete _errors[name];
        if (fieldError[1].length === 0)
            setErrors({ ..._errors });
        else
            setErrors({ ..._errors, ...fieldError[0] });

        setLayoutDiarioOficial(_layoutDiarioOficial);
    }

    const onSubmit = () => {
        //Realizando a validação dos campos obrigatorios
        const _errors = validarCampos(layoutDiarioOficial, campos);
        setErrors(_errors[0]);

        if (_errors[1].length > 0)
            return true;

        const _layoutDiarioOficial = { ...layoutDiarioOficial };

        if (_layoutDiarioOficial.id) {
            setLoading(true);
            layoutDiarioOficial_api.put(_layoutDiarioOficial)
                .then(response => {
                    showMessage("Sucesso", "Operação realizada com sucesso", "success", handleVoltar);
                })
                .catch(err => showMessage("Error", err?.message ?? "Error na operação.", "error", null))
                .finally(f => setLoading(false));
        } else {
            setLoading(true);
            layoutDiarioOficial_api.post(_layoutDiarioOficial)
                .then(response => {
                    showMessage("Sucesso", "Operação realizada com sucesso", "success", handleVoltar);
                })
                .catch(err => showMessage("Error", err?.message ?? "Error na operação.", "error", null))
                .finally(f => setLoading(false));
        }
    }

    return <>
        {isModalListaVariaveis &&
            <ModalCustomized
                toggle={toggleModalListaVariaveis}
                isOpen={isModalListaVariaveis}
                btnClose={toggleModalListaVariaveis}
                title={"Lista de variáveis"}
            >
                <TabelaListagemFichas
                    options={{ print: false, search: true, pagination: true }}
                    headers={headersListaDeVariaveis}
                    items={listaVariaveisSistema.filter(v => v.tipo == "Infração")}
                />
            </ModalCustomized>
        }
        <Button onClick={() => { handleVoltar() }} className='px-4'>
            <FontAwesomeIcon icon={faAngleLeft} className='me-2' />
            Voltar
        </Button>
        <MainCard>
            <Row className='d-flex align-items-center justify-content-between mb-4'>
                <Col md="6" lg="6" className='text-start'>
                    <h5 className='text-secondary'>Adicionar layout diário oficial</h5>
                </Col>
                <Col md="6" lg="6" className='text-end'>
                    <Button
                        color='dark'
                        className='text-white fw-bold'
                        onClick={toggleModalListaVariaveis}
                    >
                        <FontAwesomeIcon icon={faFileAlt} />  Visualizar lista de variáveis
                    </Button>
                </Col>
            </Row>
            <Row>
                <Col md={12} lg={12}>
                    <TextField
                        type={"text"}
                        label={"* Identificação"}
                        name={"identificacao"}
                        value={layoutDiarioOficial.identificacao}
                        onChange={onChange}
                        invalid={!!errors.identificacao}
                    />
                </Col>
                <Col md={12} lg={12}>
                    <TextField
                        type={"textarea"}
                        label={"* Cabeçalho"}
                        name={"cabecalho"}
                        value={layoutDiarioOficial.cabecalho}
                        onChange={onChange}
                    />
                </Col>
                <Col md={12} lg={12}>
                    <TextField
                        type={"textarea"}
                        label={"* Itens"}
                        name={"item"}
                        value={layoutDiarioOficial.item}
                        onChange={onChange}
                        invalid={!!errors.item}
                    />
                </Col>
                <Col md="12" lg="12" className={`d-flex align-items-center justify-content-center mt-4`}>
                    <Button
                        className='px-4'
                        color={id ? 'warning text-white' : 'success'}
                        onClick={onSubmit}
                    >
                        {id ? <><FontAwesomeIcon icon={faEdit} /> Atualizar</> : "+ Cadastrar"}
                    </Button>
                </Col>
            </Row>
        </MainCard>
    </>;
}

export default CadastroLayoutDiarioOficial;